// Privates local storage
const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);

// Local Storage
export const lsGetSelectedSectionFilters = section => {
  const lsSelectedSectionFilters = localStorageGetObject('selected:section:filters');
  return section ? lsSelectedSectionFilters[section] : lsSelectedSectionFilters;
};
export const lsSetSelectedSectionFilters = value =>
  localStorageSetItem('selected:section:filters', value);
export const lsRemoveSelectedSectionFilters = () => {
  localStorageRemoveItem('selected:section:filters');
};
export const lsGetSelectedPaginationFilters = section => {
  const lsSelectedPaginationFilters = localStorageGetObject('selected:pagination:filters');
  return section ? lsSelectedPaginationFilters[section] : lsSelectedPaginationFilters;
};
export const lsSetSelectedPaginationFilters = value =>
  localStorageSetItem('selected:pagination:filters', value);
export const lsRemoveSelectedPaginationFilters = () => {
  localStorageRemoveItem('selected:pagination:filters');
};
export const lsGetSelectedCommonFilters = filter => {
  const lsSelectedCommonFilters = localStorageGetObject('selected:common:filters');
  if (lsSelectedCommonFilters) {
    return lsSelectedCommonFilters[filter];
  }
  return null;
};
export const lsSetSelectedCommonFilters = value =>
  localStorageSetItem('selected:common:filters', value);
export const lsRemoveSelectedCommonFilters = () => {
  localStorageRemoveItem('selected:common:filters');
};
export const lsGetResetSection = section => {
  const lsResetSection = localStorageGetObject('reset:section');
  if (lsResetSection) {
    return section ? lsResetSection[section] : lsResetSection;
  }
  return null;
};
export const lsSetResetSection = value => {
  localStorageSetItem('reset:section', value);
};
// Helpers for store modules
export const paginationData = resp => {
  const objEmpty = {
    total: 0,
    offset: -1,
    limit: -1,
    sort: '',
    direction: 0,
    fields: null,
    Search: null
  };
  return resp.headers['x-pagination'] ? JSON.parse(resp.headers['x-pagination']) : objEmpty;
};

export const paginationOData = resp => {
  const objEmpty = {
    total: 0,
    offset: -1,
    limit: -1,
    sort: '',
    direction: 0,
    fields: null,
    Search: null
  };
  return resp.headers['x-pagination'] ? JSON.parse(resp.headers['x-pagination']) : objEmpty;
};

export const createPaginationQuery = params => {
  let queryString = '';
  const keys = Object.keys(params);
  keys.forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      if (queryString === '') {
        queryString += `?${key}=${params[key]}`;
      } else {
        queryString += `&${key}=${params[key]}`;
      }
    }
  });
  return queryString;
};
